import aviaYMLogger from './base';

export enum AviaMainPageYMLogs {
  SHOW_MORE_DESTINATIONS_BUTTON,
  CLICK_BANNER,
  HOT_OFFERS_BLOCK_VIEW,
  HOT_OFFER_CLICK,
  HOT_OFFERS_ALL_CLICK,
  HOT_OFFERS_SCROLL
}

const aviaMainPageYMLogger = aviaYMLogger.extend('main_page').bindEnum(AviaMainPageYMLogs);

export default aviaMainPageYMLogger;
